import React, { memo } from "react";
import { Checkbox, Paper } from "@mui/material";

type LocationId = string | number;

type BulkLocationCheckboxProps = {
  locationId: LocationId;
  isChecked?: boolean;
  setCheckedLocations: (
    _updater: (_previousLocations: LocationId[]) => LocationId[]
  ) => void;
  disabled?: boolean;
};

const BulkLocationCheckbox = ({
  locationId,
  isChecked = false,
  setCheckedLocations,
  disabled = false,
}: BulkLocationCheckboxProps) => {
  return (
    <Paper
      className="mr-1 mt-0 p-0"
      elevation={disabled ? 0 : 2}
      sx={{ opacity: disabled ? 0.5 : 1 }}
    >
      <Checkbox
        color="primary"
        checked={isChecked}
        disabled={disabled}
        onChange={(e) => {
          if (e.target.checked) {
            setCheckedLocations((prev) => [...prev, locationId]);
          } else {
            setCheckedLocations((prev) =>
              prev.filter((id) => id !== locationId)
            );
          }
        }}
        className="m-0 p-1"
      />
    </Paper>
  );
};

export default memo(BulkLocationCheckbox);
